import { render, staticRenderFns } from "./SWAppUpdate.vue?vue&type=template&id=792a320c&scoped=true&"
import script from "./SWAppUpdate.vue?vue&type=script&lang=ts&"
export * from "./SWAppUpdate.vue?vue&type=script&lang=ts&"
import style0 from "./SWAppUpdate.vue?vue&type=style&index=0&id=792a320c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792a320c",
  null
  
)

export default component.exports